module.exports = __webpack_public_path__ + "../../../static/img/c_im_27.f32ea54e.png";